import React from 'react';
import { useSelector } from 'react-redux';

import LinearLoader from 'Containers/Common/LinearLoader';
import { getLoader } from './store/selectors';
import styles from './Loader.module.scss';

/**
 * Loader globale: SOLO barra LinearLoader in alto.
 * Mai Spinner fullscreen — pointer-events: none così Header/Sidebar restano cliccabili.
 */
export default () => {
  const loading = useSelector(getLoader());

  if (!loading) return null;

  return (
    <div className={styles.bar} aria-busy="true" aria-hidden="true">
      <LinearLoader />
    </div>
  );
};
